<header class="main-header">
  <nav class="navbar fixed-top navbar-expand-md navbar-dark navbar-main navbar-fade" enaukaColorFade>
    <div class="container">

      <div class="float-left">
        <a [routerLink]="['/']">
          <span class="navbar-brand navbar-heading pl-1">zeszyt.online</span>
        </a>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <ul class="navbar-nav mr-auto mt-2 mt-md-0 ml-md-2">
          <li class="nav-item menu-item">
            <a href="#system" enaukaScrollable>System</a>
          </li>
          <li class="nav-item menu-item">
            <a href="#projects" enaukaScrollable>Nasze projekty</a>
          </li>
          <li class="nav-item menu-item">
            <a href="#partnership" enaukaScrollable>Współpraca</a>
          </li>
        </ul>
        <div class="form-inline pr-lg-5 pr-md-1">
          <a [routerLink]="['logowanie']"
            class="btn custom-button heading-button default-button ml-1 mt-2 mt-md-0">zaloguj się!</a>
        </div>
      </div>
    </div>

  </nav>

  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-md-8">
        <div class="brand-heading pl-1">
          <h1>Otrzymaj matematycznego opiekuna!</h1>
          Znajdujesz się na platformie z zadaniami matematycznymi, dostosowanymi do uczniów szkół
          podstawowych oraz studentów. W trakcie nauki jesteś pod stałą opieką i w każdej chwili możesz
          liczyć na naszą pomoc.
          <div class="mt-3">
            <a [routerLink]="['logowanie']" class="btn heading-button custom-button mb-3">
              przejdź do platformy!
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</header>
